/**
 * Shared maximum lengths for frontend fields.
 *
 * These values should match the limits enforced by the API and database.
 * Reuse them in:
 *
 * - maxlength
 * - counter
 * - validation rules
 *
 * Naming convention if unique:
 * <ENTITY_OR_FEATURE>_<PROPERTY>
 */
export const FIELD_MAX_LENGTHS = {
  COMMON: {
    KEY: 100,
    NAME: 100,
    DESCRIPTION: 255,
    LONG_DESCRIPTION: 2000,
    SERIAL_NUMBER: 100
  },

  PRODUCT: {
    MODEL_NUMBER: 100,
    UPC: 100,
    BARCODE: 100,
    SERIAL_NUMBER_REGEX: 100
  },

  USER_FIRST_NAME: 100,
  USER_MIDDLE_NAME: 100,
  USER_LAST_NAME: 100,

  ADDRESS_LINE_1: 200,
  ADDRESS_LINE_2: 200,
  ADDRESS_CITY: 100,

  PROMOTION_KEY: 100,
  PAYOUT_MESSAGE: 255
};

export default FIELD_MAX_LENGTHS;
